import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TableCell from "@material-ui/core/TableCell";
import Alert from "@material-ui/lab/Alert";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
  checkbox: {
    width: "25px",
    height: "25px",
  },
  button: {
    margin: "5px",
  },
  centerButton: {
    color: "white",
    backgroundColor: "#dc3545",
  },
  datailCard: {
    width: "60%",
    marginLeft: "20%",
    marginTop: "25px",
  },
});

const ReleaseTeamsEndpoint = () => {
  const classes = useStyles();
  const [userData, setUserData] = useState(null);
  const [updateType, setUpdateType] = useState("single");

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  const changeHandler = (value, name) => {
    clearAlert();
    if (value == "single" || value == "bulk") {
      setUserData(null);
      setUpdateType(value);
      return;
    }
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <Typography
              sx={{ fontSize: 14 }}
              style={{ margin: "20px", fontSize: "1.5em" }}
              color="text.secondary"
              gutterBottom
            >
              Release Teams
            </Typography>
            <div class="mb-3 row">
              <div class="col-sm-1 col-form-label" />
              <div class="col-sm-9">
                <RadioGroup
                  row
                  name="row-radio-buttons-group"
                  onChange={(e) => changeHandler(e.target.value, e.target.name)}
                  defaultValue="single"
                >
                  <FormControlLabel
                    default
                    value="single"
                    control={<Radio color="primary" />}
                    label="Single"
                  />
                  <FormControlLabel
                    value="bulk"
                    control={<Radio color="primary" />}
                    label="Bulk"
                  />
                </RadioGroup>
              </div>
            </div>
            {updateType == "single" ? (
              <SingleRelease
                sendAlert={sendAlert}
                clearAlert={clearAlert}
                userData={userData}
                setUserData={setUserData}
              />
            ) : (
              <BulkRelease sendAlert={sendAlert} clearAlert={clearAlert} />
            )}
          </Card>
        </div>
      </div>
      {userData != null && (
        <EndpointData
          sendAlert={sendAlert}
          userData={userData}
          clearAlert={clearAlert}
          setUserData={setUserData}
        />
      )}
    </>
  );
};

const EndpointData = (props) => {
  const classes = useStyles();
  const { sendAlert, clearAlert, userData, setUserData } = props;
  const [loading, setLoading] = useState(false);

  const releaseEndpoint = (e) => {
    e.preventDefault();
    clearAlert();
    setLoading(true);

    let identifier = userData.gmin?.toString() ?? `byGMID/${userData.gmid}`;

    // Extract only the GMID for alerts
    const gmidForAlert = identifier.startsWith("byGMID/")
      ? identifier.replace("byGMID/", "")
      : identifier;
    fetchWithToken(`api/TeamsEndpoint/release/${identifier}`, "DELETE").then(
      (res) => {
        if (res.ok) {
          sendAlert(
            `Endpoint linked to ${gmidForAlert} - Successfully Released`,
            "success"
          );
          setUserData(null);
        } else if (res.status === 409) {
          sendAlert(`Conflict - Unable to Release Endpoint`, "danger");
        } else {
          sendAlert(
            `Unknown Error - Error Releasing Endpoint linked to ${gmidForAlert}`,
            "warning"
          );
        }
        setLoading(false);
      }
    );
  };

  const getDateFormat = (date) => {
    if (date == null) return;
    var newDate = date.split("T")[0];
    var dateArray = newDate.split("-");
    var year = dateArray[0];
    var month = dateArray[1];
    var day = dateArray[2];
    var fullTime = date.split("T")[1].split(".")[0];
    var hour = fullTime.substring(0, 2);
    var finalTime;
    if (parseInt(hour) > 12) {
      if (parseInt(hour) > 21) {
        finalTime = hour - 12 + fullTime.substring(2, 5);
      } else {
        finalTime = "0" + (hour - 12) + fullTime.substring(2, 5);
      }
      finalTime += " PM";
    } else {
      finalTime = hour + fullTime.substring(2, 5);
      finalTime += " AM";
    }
    var myDate = `${year}-${month}-${day}`;
    return myDate;
  };

  return (
    <>
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <Card className={classes.datailCard}>
            <CardContent>
              <Typography
                sx={{ fontSize: 14 }}
                style={{ margin: "20px", fontSize: "1.5em" }}
                color="text.secondary"
                gutterBottom
              >
                Existing Endpoint
              </Typography>
              <form style={{ margin: "20px" }} onSubmit={releaseEndpoint}>
                <div class="mb-3 row">
                  <div class="col-sm-1" />
                  <div class="col-sm-3">
                    <h6>Number:</h6>
                  </div>
                  <div class="col-sm-7">
                    <h6>{userData.phoneNumber}</h6>
                  </div>
                  <div class="col-sm-1" />
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-1" />
                  <div class="col-sm-3">
                    <h6>GMID:</h6>
                  </div>
                  <div class="col-sm-7">
                    <h6>{userData.gmid}</h6>
                  </div>
                  <div class="col-sm-1" />
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-1" />
                  <div class="col-sm-3">
                    <h6>GMIN:</h6>
                  </div>
                  <div class="col-sm-7">
                    <h6>{userData.gmin}</h6>
                  </div>
                  <div class="col-sm-1" />
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-1" />

                  <div class="col-sm-3">
                    <h6>Display Name:</h6>
                  </div>
                  <div class="col-sm-7">
                    <h6>{userData.displayName}</h6>
                  </div>
                  <div class="col-sm-1" />
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-1" />

                  <div class="col-sm-3">
                    <h6>Pool Name:</h6>
                  </div>
                  <div class="col-sm-7">
                    <h6>{userData.pool.name}</h6>
                  </div>
                  <div class="col-sm-1" />
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-1" />

                  <div class="col-sm-3">
                    <h6>Dial Plan:</h6>
                  </div>
                  <div class="col-sm-7">
                    <h6>{userData.dialPlan}</h6>
                  </div>
                  <div class="col-sm-1" />
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-1" />

                  <div class="col-sm-3">
                    <h6>Voice Policy:</h6>
                  </div>
                  <div class="col-sm-7">
                    <h6>{userData.voicePolicy}</h6>
                  </div>
                  <div class="col-sm-1" />
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-1" />

                  <div class="col-sm-3">
                    <h6>Assignment Date:</h6>
                  </div>
                  <div class="col-sm-7">
                    <h6 style={{ minWidth: "200px" }}>
                      {getDateFormat(userData.assignmentDate)}
                    </h6>
                  </div>
                  <div class="col-sm-1" />
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-1" />

                  <div class="col-sm-3">
                    <h6>SIP Address</h6>
                  </div>
                  <div class="col-sm-7">
                    <h6>{userData.sipAddress}</h6>
                  </div>
                  <div class="col-sm-1" />
                </div>

                {loading && (
                  <>
                    <div style={{ margin: "25px" }}>
                      <span style={{ display: "table", margin: "0 auto" }}>
                        Please Wait For Release to Finish
                      </span>
                      <LinearProgress />
                    </div>
                  </>
                )}

                <Button
                  style={{ margin: "10px" }}
                  type="submit"
                  variant="contained"
                  className={classes.centerButton}
                >
                  Release
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

const SingleRelease = (props) => {
  const { sendAlert, clearAlert, setUserData } = props;
  const classes = useStyles();
  const [upnInput, setUPNInput] = useState("");
  const [numberInput, setNumberInput] = useState("");
  const [loading, setLoading] = useState(false);

  const inputChangeHandler = (e) => {
    if (e.target.id == "gminSearch") {
      setNumberInput("");
      setUPNInput(e.target.value);
    } else {
      setUPNInput("");
      setNumberInput(e.target.value);
    }
  };

  console.log("upnInput: ", upnInput);

  const userLookup = (e) => {
    e.preventDefault();
    clearAlert();
    setUserData(null);
    var searchType;
    var searchValue;
    var gmin = e.target.gminSearch.value;
    var number = e.target.numberSearch.value;

    console.log("gmin", gmin);
    console.log("number", number);

    if (gmin < 1 && number.length >= 1) {
      searchType = "ByNumber";
      searchValue = number;
    } else if (number.length < 1 && gmin.length >= 1) {
      searchType = "ByGMIN";
      searchValue = gmin;
    } else {
      return sendAlert(`GMIN or Phone Number Required`, "warning");
    }

    setLoading(true);
    let success = false;

    console.log("searchType", searchType);
    console.log("searchValue", searchValue);

    fetchWithToken(`api/TeamsEndpoint/${searchType}/${searchValue}`)
      .then((res) => {
        console.log("ok", res.ok);
        if (res.ok) success = true;
        return res.json();
      })
      .then((data) => {
        if (data != null) {
          console.log("data", data);
          console.log("data", data.returnMessage);
          console.log("data", data.returnObject);
          sendAlert(data.returnMessage, success ? "success" : "warning");
          setUserData(data.returnObject);
          setLoading(false);
        }
      });
  };

  return (
    <form style={{ margin: "25px" }} onSubmit={(e) => userLookup(e)}>
      <div class="mb-3 row">
        <TableCell class="col" style={{ width: "45%" }}>
          <input
            type="number"
            class="form-control"
            name="gminSearch"
            id="gminSearch"
            value={upnInput}
            placeholder="Search GMIN"
            maxlength="40"
            onChange={(e) => {
              clearAlert();
              inputChangeHandler(e);
            }}
          />
        </TableCell>
        <Typography
          sx={{ fontSize: 14 }}
          style={{ margin: "auto" }}
          color="text.secondary"
          gutterBottom
        >
          OR
        </Typography>
        <TableCell class="col" style={{ width: "45%" }}>
          <input
            type="number"
            class="form-control"
            name="numberSearch"
            id="numberSearch"
            value={numberInput}
            placeholder="Search Phone Number"
            onChange={(e) => {
              clearAlert();
              inputChangeHandler(e);
            }}
          />
        </TableCell>
      </div>
      {loading && (
        <>
          <div style={{ margin: "25px" }}>
            <span style={{ display: "table", margin: "0 auto" }}>
              Searching For Endpoint
            </span>
            <LinearProgress />
          </div>
        </>
      )}
      <Button
        type="submit"
        variant="contained"
        style={{ margin: "10px" }}
        className={classes.button}
        color="primary"
      >
        Look Up
      </Button>
    </form>
  );
};

const BulkRelease = (props) => {
  const { sendAlert, clearAlert } = props;
  const classes = useStyles();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [providedGmins, setProvidedGMINs] = useState({ userGMINs: [] });
  const [loading, setLoading] = useState(false);

  //Handlers
  //const fileChangeHandler = (event) => {
  //  clearAlert();
  //  handleCancel();
  //  var file = event.target.files[0];
  //  event.target.value = "";
  //  setSelectedFile(file);
  //  setIsSelected(true);
  //  var reader = new FileReader();
  //  reader.onload = function (event) {
  //    var splitArray = event.target.result.split("\r\n");
  //    splitArray = splitArray.filter(Boolean);
  //    var userArray = [];
  //    splitArray.map((user) => {
  //      userArray.push(user.toUpperCase());
  //    });
  //    if (userArray == "") {
  //      setIsEmpty(true);
  //      console.log("No Content", "warning");
  //    } else {
  //      setIsEmpty(false);
  //      setBulkReleaseData({
  //        userGMINs: userArray,
  //      });
  //    }
  //  };
  //  reader.readAsText(file);
  //};

  const fileChangeHandler = (event) => {
    handleCancel();
    clearAlert();

    const file = event.target.files[0];
    event.target.value = "";
    setSelectedFile(file);
    setIsSelected(true);

    const reader = new FileReader();
    reader.onload = function (event) {
      const lines = event.target.result.split(/\r?\n/).filter(Boolean);
      const validNumbersSet = new Set();

      for (let line of lines) {
        const trimmed = line.trim();
        if (!isNaN(trimmed)) {
          validNumbersSet.add(Number(trimmed));
        }
      }

      const validNumbers = Array.from(validNumbersSet);

      if (validNumbers.length === 0) {
        setIsEmpty(true);
        console.log("No valid numbers found", "warning");
      } else {
        setIsEmpty(false);
        setProvidedGMINs({ userGMINs: validNumbers }); // validNumbers is number[]
      }
    };

    reader.readAsText(file);
  };

  const handleCancel = (event) => {
    clearAlert();
    setSelectedFile(null);
    setIsSelected(false);
    setProvidedGMINs({
      userGMINs: [],
    });
  };

  const bulkSubmit = (e) => {
    e.preventDefault();
    clearAlert();
    if (isEmpty) {
      sendAlert("No Content", "warning");
      return;
    }
    if (!isSelected) {
      sendAlert("No File Selected", "warning");
      return;
    }
    setLoading(true);

    fetchWithToken(
      `api/TeamsEndpoint/bulkRelease/`,
      "DELETE",
      providedGmins
    ).then((res) => {
      if (res.ok) {
        sendAlert(`File Successfully Submitted`, "success");
        setLoading(false);
      } else {
        sendAlert(`Conflict - Error Submitting Files`, "danger");
        setLoading(false);
      }
    });
    handleCancel();
  };

  return (
    <>
      {loading && (
        <>
          <div style={{ margin: "25px" }}>
            <span style={{ display: "table", margin: "0 auto" }}>
              Please Wait For Bulk Release to Finish
            </span>
            <LinearProgress />
          </div>
        </>
      )}
      <form onSubmit={bulkSubmit} style={{ margin: "25px" }}>
        <div class="mb-3 row">
          <TableCell class="col-sm-8">
            Upload File:{" "}
            {isSelected && (
              <>
                {selectedFile.name} ({providedGmins.userGMINs.length}{" "}
                GMINs/Numbers)
              </>
            )}
            <br />
            <Button
              variant="contained"
              component="label"
              className={classes.button}
              color="primary"
            >
              Select File
              <input
                type="file"
                name="file"
                accept=".txt"
                onChange={fileChangeHandler}
                hidden
              />
            </Button>
            <Button
              type="submit"
              variant="contained"
              className={classes.button}
              color="primary"
            >
              Submit
            </Button>
            <Button
              variant="contained"
              onClick={handleCancel}
              className={classes.button}
            >
              Cancel
            </Button>
          </TableCell>
        </div>
      </form>
    </>
  );
};

export default ReleaseTeamsEndpoint;
